import React from 'react';
import { createRoot } from 'react-dom/client';

import readAttribute from 'common/tools/dom/readAttribute';

import SeenItButton from 'website/components/SeenItButton';
import allocineContainer from 'website/containers/allocineContainer';

export default function seenItActions() {
  const ConnectedSeenItButton = allocineContainer(SeenItButton);

  const anchors = document.getElementsByClassName('js-seenit-btn');

  if (anchors.length) {
    for (const anchor of anchors) {
      const entityId = readAttribute(anchor, 'data-entity-id');
      // if entity is series_season or series_episode, we need to get entity series for tracking
      const baseEntityId = readAttribute(anchor, 'data-base-entity-id');
      const text = readAttribute(anchor, 'data-text');
      const className = readAttribute(anchor, 'data-class-name');

      const root = createRoot(anchor);
      root.render(
        <ConnectedSeenItButton
          baseEntityId={baseEntityId}
          entityId={entityId}
          text={text}
          className={className}
        />
      );
    }
  }
}
